import React from 'react';
import IdentifyUserContainer from 'modules/Authentication/containers/IdentifyUserContainer/IdentifyUserContainer';

type Props = {};

const IdentifyUser = (props: Props) => {
   return <IdentifyUserContainer />;
};

export default IdentifyUser;
